const CUSTOM_EMOJI_TOKEN_PREFIX = ':cae:' // Cripto Alert Emoji

export const COMMUNITY_CUSTOM_EMOJI_STORAGE_BUCKET = 'assets'
export const COMMUNITY_CUSTOM_EMOJI_STORAGE_PREFIX = 'community/emojis'

export type CommunityCustomEmojiToken = {
  id: string
}

export function buildCommunityCustomEmojiToken(id: string): string {
  const trimmed = String(id || '').trim()
  return trimmed ? `${CUSTOM_EMOJI_TOKEN_PREFIX}${trimmed}:` : ''
}

export function parseCommunityCustomEmojiToken(input: string): CommunityCustomEmojiToken | null {
  const raw = String(input || '')
  if (!raw.startsWith(CUSTOM_EMOJI_TOKEN_PREFIX)) return null
  const rest = raw.slice(CUSTOM_EMOJI_TOKEN_PREFIX.length)
  const lastColon = rest.lastIndexOf(':')
  if (lastColon < 0) return null
  const id = rest.slice(0, lastColon).trim()
  if (!id) return null
  return { id }
}

export function isCommunityCustomEmojiToken(input: string): boolean {
  return !!parseCommunityCustomEmojiToken(input)
}

export function buildCommunityCustomEmojiStoragePath(id: string): string {
  const trimmed = String(id || '').trim()
  return trimmed ? `${COMMUNITY_CUSTOM_EMOJI_STORAGE_PREFIX}/${trimmed}` : ''
}

export function buildCommunityCustomEmojiPublicUrl(id: string): string | null {
  const supabaseUrl = (import.meta as any).env?.VITE_SUPABASE_URL as string | undefined
  if (!supabaseUrl) return null
  const path = buildCommunityCustomEmojiStoragePath(id)
  if (!path) return null
  const base = supabaseUrl.replace(/\/$/, '')
  return `${base}/storage/v1/object/public/${COMMUNITY_CUSTOM_EMOJI_STORAGE_BUCKET}/${path}`
}
